<template>
  <div style="text-align: center">
    <!-- 登录二维码 -->
    <div id="wx_login_container" ref="loginContainer" v-if="!isAuth"></div>

    <div v-else>
      <Spin fix></Spin>
      扫描成功...
    </div>

    <div v-if="!refresQrCode" class="refresh_wx_qrCode">
      <Spin fix></Spin>
    </div>

    <div v-if="refresQrCode" class="refresh_wx_login" @click="init('qrCode')">刷新二维码</div>
  </div>
</template>
<script>
  // import * as config from './config'
  import {
    Spin
  } from 'iview'
  import {
    SOCKETIP
  } from '../../common/config'
  //声明对象
  window.wxAuthObj = null;
  let appid = "wxbe02c74cfbd6aca7";
  let redirectUri = "https://apollo.qiein.com/third_login/wechat_callback";
  let websocket;
  export default {
    name: 'wx-auth',
    data() {
      return {
        //是否已经得到了CODE
        isAuth: false,
        authCode: null,
        token: '',
        refresQrCode:true,
      }
    },
    components: {
      Spin,
    },
    created: function () {
      window.wxAuthObj = this;
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      if (websocket) {
        websocket.close();
      }
    },
    methods: {
      init(value) {
        if(value == 'qrCode'){
          this.refresQrCode = false
        }
        this.$http.get('/outer/get_uuid').then(res => {
          this.token = res.data
          this.createSocket()
          this.createQrCode();
          this.refresQrCode = true
        });

      },
      createSocket() {
        websocket = new WebSocket(`${SOCKETIP}?token=${this.token}`);
        //接收消息
        websocket.onmessage = (event) => {
          if (event.data) {
            //判断是否传过来公司列表
            let message = JSON.parse(event.data);
            this.$emit('on-success', {
              token: this.token,
              companyList: message
            });
          }
        }
      },
      //创建二维码
      createQrCode() {
        let obj = new WxLogin({
          self_redirect: true,
          id: "wx_login_container",
          appid: appid,
          scope: "snsapi_login",
          redirect_uri: redirectUri,
          state: this.token,
          style: "",
          href: "https://crm-jupiter.oss-cn-hangzhou.aliyuncs.com/wx_qr_code.css"
        });
      },
    }
  }

</script>

<style>
  .wx_login_container{
    position: relative;
  }
  .refresh_wx_login{
    font-size:12px;
    color:#2d8cf0;
    border-radius: 1px;
    text-align: center;
    cursor: pointer;
  }
  .refresh_wx_qrCode{
    position: absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background:rgba(255,255,255,.6);
  }
</style>



// WEBPACK FOOTER //
// src/components/sing-in/wx-auth.vue